import {Button, Header, SpaceBetween, TableProps} from "@amzn/awsui-components-react";
import ReactTooltip from "react-tooltip";
import React, {FunctionComponent, MutableRefObject} from "react";

export interface DownloadButtonDetails {
    onClickDownload: {(): void}
    tooltip: string
    tooltipPlacement: string
}

export interface HeaderDetails {
    header: string
    fileName: string
    data: string[][]
    csvInstance: MutableRefObject<any>
    downloadButtonDetails: DownloadButtonDetails
    onClickViewAll: {(): void}
    AdditionalAction?: FunctionComponent
}

export const getHeaders = (columnDefinitions: TableProps.ColumnDefinition<any>[]) => {
    return [columnDefinitions.map(({header}) => header as string)]
}

export const toBlobString = (items: string[][]) => {
    return '\ufeff' + items.join('\n')
}

const downloadButton = (onClickFunc: () => void, tooltip: string, tooltipPlacement: string) => (
    <Button
        data-tip={tooltip}
        data-place={tooltipPlacement}
        variant='icon'
        iconName={'download'}
        onClick={() => { onClickFunc() }}
    />
)

const viewAllButton = (onClickFunc:  () => void) => (
    <Button
        data-tip={'View All'}
        variant='icon'
        iconName={'external'}
        onClick={() => { onClickFunc() }}
    />
)

export const getBlobUrl = (data: string[][], type: string) => {
    const file = new Blob([toBlobString(data)], {type: type})
    return URL.createObjectURL(file)
}

export const tableHeader = ({
    header,
    fileName,
    data,
    csvInstance,
    downloadButtonDetails,
    onClickViewAll,
    AdditionalAction
}: HeaderDetails) => (
    <div className={'TableHeader'}>
        <Header variant='h2' actions={
            <SpaceBetween
                direction="horizontal"
                alignItems="center"
                size="m"
            >
                {AdditionalAction && <AdditionalAction />}
                <div className={'TableButtons'}>
                    {downloadButton(
                        downloadButtonDetails.onClickDownload,
                        downloadButtonDetails.tooltip,
                        downloadButtonDetails.tooltipPlacement
                    )}
                    {viewAllButton(onClickViewAll)}
                </div>
            </SpaceBetween>
        }>{header}</Header>
        <ReactTooltip multiline={true} />
        <a
            style={{display: "none"}}
            download={`${fileName}.csv`}
            target={'_self'}
            href={getBlobUrl(data, 'text/csv')}
            ref={csvInstance}
        >empty</a>
    </div>
)